export default __webpack_public_path__ + "static/media/DK_Layout_1.b6764b52.png";